<template>
    <v-container
        fluid
        grid-list-lg
    >
        <v-layout wrap>
            <v-flex xs12>
                <v-slide-y-transition mode="out-in">
                    <custom-table
                        ref="customTable"

                        data-url="/leads/index"
                        :single-item-name="'lead'"
                        :plural-item-name="'leads'"
                        :headers="headers"
                        :freeze="updating"
                        :breakpoint="950"

                        :customClasses="trClass"

                        :create-button="false"

                        clickable
                        @click="view"
                    >
                        <template
                            slot="row"
                            slot-scope="props"
                        >
                            <td>
                                {{ props.item.leadReference }}

                                <v-tooltip
                                    bottom
                                    v-if="props.item.source"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            $mdiInboxArrowDown
                                        </v-icon>
                                    </template>
                                    <span>
                                        {{ props.item.source_name }}
                                    </span>
                                </v-tooltip>

                                <v-tooltip
                                    bottom
                                    v-if="props.item.promotion"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            $mdiMessageArrowRightOutline
                                        </v-icon>
                                    </template>
                                    <span>
                                        {{ props.item.promotion.Name }}
                                    </span>
                                </v-tooltip>
                            </td>
                            <td>
                                {{ props.item.leadFirstName + ' ' + props.item.leadLastName }}
                            </td>
                            <td>
                                {{ props.item.leadCreateDate }}
                            </td>
                            <td>
                                {{ props.item.status_name }}
                                <v-btn
                                    v-if="typeof props.item.last_comment !== 'undefined' && props.item.last_comment !== null"
                                    @click.stop="viewComment(props.item)"
                                    icon
                                >
                                    <v-icon>
                                        $mdiCommentProcessingOutline
                                    </v-icon>
                                </v-btn>

                                <v-tooltip
                                    bottom
                                    v-if="typeof props.item.policy !== 'undefined' && props.item.policy !== null"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            $mdiFileDocumentEdit
                                        </v-icon>
                                    </template>
                                    <span>
                                        {{ props.item.policy.PolicyMasterCode }} - {{
                                        props.item.policy.plan_details.product_name }}
                                    </span>
                                </v-tooltip>

                                <v-tooltip
                                    bottom
                                    v-if="typeof props.item.last_quote !== 'undefined' && props.item.last_quote !== null"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            $mdiFileDocumentOutline
                                        </v-icon>
                                    </template>
                                    <span>
                                        {{ props.item.last_quote.reference_number }} - {{
                                        props.item.last_quote.selected_lpp_label }} LPP - R{{
                                        props.item.last_quote.total_premium }}
                                    </span>
                                </v-tooltip>
                            </td>
                            <td>
                                <template
                                    v-if="typeof props.item.telephonist !== 'undefined' && props.item.telephonist !== null && typeof props.item.telephonist.FirstName !== 'undefined' && typeof props.item.telephonist.LastName !== 'undefined'"
                                >
                                    {{ props.item.telephonist.FirstName + ' ' + props.item.telephonist.LastName }}
                                </template>
                            </td>
                            <td>
                                <template
                                    v-if="typeof props.item.fo !== 'undefined' && props.item.fo !== null  && typeof props.item.fo.FirstName !== 'undefined' && typeof props.item.fo.LastName !== 'undefined'"
                                >
                                    {{ props.item.fo.FirstName + ' ' + props.item.fo.LastName }}
                                </template>
                            </td>
                            <td>
                                {{ props.item.dateAppointment }}
                            </td>
                        </template>

                        <template
                            slot="card"
                            slot-scope="props"
                        >
                            <td
                                class="v-data-table__mobile-row"
                                v-for="(header, headerIndex) in headers"
                                :key="headerIndex"
                            >
                                <div class="v-data-table__mobile-row__header">
                                    {{ header.text }}
                                </div>
                                <div class="v-data-table__mobile-row__cell">
                                    <template
                                        v-if="header.value === 'names'"
                                    >
                                        {{ props.item.leadFirstName + ' ' + props.item.leadLastName }}
                                    </template>
                                    <template
                                        v-else-if="header.value === 'leadReference'"
                                    >
                                        {{ props.item.leadReference }}
                                        <v-tooltip
                                            bottom
                                            v-if="props.item.source"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    $mdiInboxArrowDown
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ props.item.source_name }}
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip
                                            bottom
                                            v-if="props.item.promotion"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    $mdiMessageArrowRightOutline
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ props.item.promotion.Name }}
                                            </span>
                                        </v-tooltip>
                                    </template>
                                    <template
                                        v-else-if="header.value === 'status'"
                                    >
                                        {{ props.item.status_name }}
                                        <v-btn
                                            v-if="typeof props.item.last_comment !== 'undefined' && props.item.last_comment !== null"
                                            @click.stop="viewComment(props.item)"
                                            icon
                                        >
                                            <v-icon>
                                                $mdiCommentProcessingOutline
                                            </v-icon>
                                        </v-btn>

                                        <v-tooltip
                                            bottom
                                            v-if="typeof props.item.policy !== 'undefined' && props.item.policy !== null"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    $mdiFileDocumentEdit
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ props.item.policy.PolicyMasterCode }} - {{
                                                props.item.policy.plan_details.product_name }}
                                            </span>
                                        </v-tooltip>

                                        <v-tooltip
                                            bottom
                                            v-if="typeof props.item.last_quote !== 'undefined' && props.item.last_quote !== null"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    $mdiFileDocumentOutline
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ props.item.last_quote.reference_number }} - {{
                                                props.item.last_quote.selected_lpp_label }} LPP - R{{
                                                props.item.last_quote.total_premium }}
                                            </span>
                                        </v-tooltip>
                                    </template>
                                    <template
                                        v-else-if="header.value === 'booking_agent'"
                                    >
                                        <template
                                            v-if="typeof props.item.telephonist !== 'undefined' && props.item.telephonist !== null && typeof props.item.telephonist.FirstName !== 'undefined' && typeof props.item.telephonist.LastName !== 'undefined'"
                                        >
                                            {{ props.item.telephonist.FirstName + ' ' + props.item.telephonist.LastName
                                            }}
                                        </template>
                                    </template>
                                    <template
                                        v-else-if="header.value === 'consultant'"
                                    >
                                        <template
                                            v-if="typeof props.item.fo !== 'undefined' && props.item.fo !== null  && typeof props.item.fo.FirstName !== 'undefined' && typeof props.item.fo.LastName !== 'undefined'"
                                        >
                                            {{ props.item.fo.FirstName + ' ' + props.item.fo.LastName }}
                                        </template>
                                    </template>
                                    <template
                                        v-else
                                    >
                                        {{ $refs.customTable.getCardValue(props.item, header.value) }}
                                    </template>
                                </div>
                            </td>
                            <td
                                class="v-data-table__mobile-row"
                            >
                                <div
                                    class="text-center w-full"
                                >
                                    <v-btn
                                        :color="$vuetify.theme.dark ? 'white' : 'primary'"
                                        :class="$vuetify.theme.dark ? 'black--text' : 'white--text'"
                                        small
                                        @click="view(props.item)"
                                        :small="isMobile"
                                    >
                                        View
                                    </v-btn>
                                </div>
                            </td>
                        </template>
                    </custom-table>
                </v-slide-y-transition>
            </v-flex>
        </v-layout>
        <v-dialog
            v-model="commentDialog"
            width="500"
            @click:outside="closeComment"
        >
            <v-card
                v-if="tmpLead"
            >
                <v-card-title>
                    {{ tmpLead.last_comment.user_name }} - {{ tmpLead.last_comment.dateCreated }}
                </v-card-title>

                <v-card-text>
                    {{ tmpLead.last_comment.comment }}
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        :color="$vuetify.theme.dark ? 'white' : 'primary'"
                        text
                        @click="closeComment"
                        :small="isMobile"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>
    export default {
        data() {
            return {
                headers: [
                    {text: 'Reference', value: 'leadReference', align: 'left', sortable: false},
                    {text: 'Names', value: 'names', align: 'left', sortable: false},
                    {text: 'Submitted', value: 'leadCreateDate', align: 'left', sortable: false},
                    {text: 'Status', value: 'status', align: 'left', sortable: false},
                    {text: 'Booking Agent', value: 'booking_agent', align: 'left', sortable: false},
                    {text: 'Consultant', value: 'consultant', align: 'left', sortable: false},
                    {text: 'Appointment', value: 'dateAppointment', align: 'left', sortable: false},
                ],

                updating: false,

                tmpLead: null,
                commentDialog: false,
            }
        },
        name: 'Leads-Index',
        mounted() {
            this.$store.dispatch('resources/getResource', 'leadStatuses')
                .then(response => {
                    this.$store.dispatch('table/addToFilters', {type: 'status', data: response});
                });

            this.$store.dispatch('resources/getResource', 'leadSources')
                .then(response => {
                    this.$store.dispatch('table/addToFilters', {type: 'source', data: response});
                });

            this.$store.dispatch('resources/getResource', 'leadPromotions')
                .then(response => {
                    this.$store.dispatch('table/addToFilters', {type: 'promotion', data: response});
                });

            this.$store.dispatch('resources/getResource', 'leadFeedback')
                .then(response => {
                    this.$store.dispatch('table/addToFilters', {type: 'feedback', data: response});
                });
        },
        methods: {
            view(item) {
                this.$router.push('/my-leads/view/' + item.leadId + '?tab=info');
            },

            viewComment(item) {
                this.tmpLead = item;
                this.commentDialog = true;
            },
            closeComment() {
                this.commentDialog = false;
                this.tmpLead = null;
            },

            trClass(item) {
                if (item.feedback_overdue) {
                    return 'error';
                }

                return '';
            }
        },
    }
</script>
